import { withCompInfo } from '../../core/withCompInfo'
import { RichTextBoxDefinition, RichTextBoxProps, RichTextBoxCSSVars, RichTextCarmiData } from './types'

const getToolbarPosition = (
	toolbarPosition: RichTextBoxProps['toolbarPosition'],
	isMobileView: boolean
): RichTextBoxProps['toolbarPosition'] => {
	if (isMobileView) {
		return 'bottom'
	}

	return toolbarPosition
}

export const props = withCompInfo<RichTextBoxProps, RichTextBoxDefinition>(
	['compData', 'compProps', 'isMobileView'],
	({ compData, compProps, isMobileView }) => {
		const toolbarPosition = getToolbarPosition(compProps.toolbarPosition, isMobileView)
		// TODO : missing props: isDisabled, can't figure where they come from.
		const result: RichTextBoxProps = {
			allowLinks: compProps.allowLinks,
			placeholder: compProps.placeholder,
			value: compData.value,
			textAlignment: compProps.textAlignment,
			toolbarPosition,

			readOnly: compProps.readonly ? compProps.readonly : false,
		}

		if (compData.maxLength) {
			result.maxLength = compData.maxLength
		}

		return result
	}
)

export const css = withCompInfo<RichTextBoxCSSVars, RichTextBoxDefinition, RichTextCarmiData>(
	['compProps'],
	({ compProps }, carmiData) => {
		const textPadding = compProps.textPadding && compProps.textPadding > 0 ? compProps.textPadding : 0

		return {
			'--fontSize': `${carmiData.font.size}px`,
			'--textPadding': `${textPadding}px`,
			'--textPaddingTop': `${textPadding / 2}px`,
		}
	}
)
